import { render, staticRenderFns } from "./TableSortHeader.vue?vue&type=template&id=7141e8ca&scoped=true&"
import script from "./TableSortHeader.vue?vue&type=script&lang=ts&"
export * from "./TableSortHeader.vue?vue&type=script&lang=ts&"
import style0 from "./TableSortHeader.vue?vue&type=style&index=0&id=7141e8ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7141e8ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
